var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"icon-wrapper ",attrs:{"href":_vm.icon.action,"target":"_blank"}},[_c('div',{staticClass:"icon",style:({ backgroundImage: ("url(" + (_vm.icon.src) + ")") })})])}
var staticRenderFns = []

export { render, staticRenderFns }